import React from 'react'
import * as rn from 'react-native'

import * as c from '../../../common'
import * as common from '../../../common'
import * as r from '../../../react-utils'

import * as Mui from '@mui/material'
import SimpleLineIcons from 'react-native-vector-icons/SimpleLineIcons'
import { kebabCase } from 'change-case'
import { ErrorBoundary } from 'react-error-boundary'
import { Link, useNavigate, useParams } from 'react-router-dom'

import * as cp from '../../comps'
import * as cpm from '../../../app/components'
import * as gs from '../../../app/gStyles'
import CloserCalc from '../../../app/components/CloserCalc'
import MediaInput from '../../comps/MediaInput'
import MpuCalculator from '../../../app/components/ModalMpuCalculator'
import NavMenu from '../../../app/components/NavMenu'
import NotFound from '../../comps/NotFound'
import Pad from '../../comps/Pad'

//@ts-ignore
import gStyles from '../../global.module.css'

//@ts-ignore
import styles from './Customer.module.css'

export interface CustomerProps {}

/**
 * Keep cutoff in sync with <MediaInput />'s
 */
const smallScreenMediaQuery = window.matchMedia('(max-width: 1200px)')

export default React.memo<CustomerProps>(function Customer() {
  //#region styling
  const t = r.useTheme()
  const themedGStyles = gs.useGlobalStyles('canvas')
  const _colorScheme = rn.useColorScheme()
  const colorScheme = _colorScheme === 'unspecified' ? 'light' : _colorScheme
  const inputDecors = cpm.inputDecorations[colorScheme].canvas
  // Only used for the icon for now
  const mStyles = gs.useThemedStyleSheet(themedStyles, 'backdrop')

  // React.useEffect(() => {
  //   // document.body.style.alignItems = 'center'
  //   // document.body.style.display = 'flex'
  //   // document.body.style.flexDirection = 'column'

  //   // document.body.style.paddingLeft = String((t.canvas.gap || 0) * 2) + 'px'
  //   // document.body.style.paddingRight = String((t.canvas.gap || 0) * 2) + 'px'
  //   // @ts-ignore
  //   !r.isSafari() && (document.body.style.zoom = 0.72)
  //   return (): void => {
  //     // document.body.style.alignItems = 'unset'
  //     // document.body.style.display = 'unset'
  //     // document.body.style.flexDirection = 'unset'
  //     // document.body.style.paddingLeft = 'unset'
  //     // document.body.style.paddingRight = 'unset'
  //     // @ts-ignore
  //     !r.isSafari() && (document.body.style.zoom = 1)
  //   }
  // }, [t.canvas.gap])
  //#endregion styling

  const customerID = useParams<'customerID'>().customerID!

  //#region global
  const { appliedLoan } = r.usePayment(customerID)
  const totalCostCompany = r.useTotalCost('company', customerID)
  const totalCostCustomer = r.useTotalCost('customer', customerID)

  const selectCustomer = React.useMemo(
    (): ReturnType<typeof common.makeSelectCustomer> =>
      common.makeSelectCustomer(),
    [],
  )

  const selectCustomerArgs = React.useMemo((): common.SelectCustomerParams => {
    if (typeof customerID === 'string') {
      return { customerID }
    } else {
      return { customerID: '' }
    }
  }, [customerID])

  const customer = common.useSelector(
    (_): common.Customer => selectCustomer(_, selectCustomerArgs),
  )

  const { currProducts } = r.useProducts(customerID)

  const categoryToMediaKindsEntries = r.useCategoryToMediaKinds(customerID)
  //#endregion global

  //#region local
  const [cctvSimOpen, , toggleCCTVSim] = r.useBool(false)
  const [, , payMethodToggle] = r.useSessionVal('payMethodOpen')

  const [closerCalcOpen, , toggleCloserCalc] = r.useBool(false)
  const [mpuCalculatorOpen, , toggleMpuCalculator] = r.useBool(false)
  const [, refresh] = React.useState(Math.random())
  const [navMenuOpen, setNavMenuOpen, toggleNavMenu] = r.useBool(
    !smallScreenMediaQuery.matches,
  )
  const availNonCustomEfficiencies = React.useMemo(
    (): c.CustomerFields =>
      c.efficiencyKeys
        .filter((f) => !f.startsWith('custom'))
        .filter((f) => !c.shouldHideInput(f, customer)),
    [customer],
  )
  const [solarSurveyMediaKinds] = r.useSolarSurveyMedia(customerID)
  const securityCamsMediaKinds = r.useSecurityCamAngles(customerID)
  //#endregion local

  const handleScreenSizeChange = React.useCallback((): void => {
    const isSmallScreen = smallScreenMediaQuery.matches

    if (isSmallScreen) {
      setNavMenuOpen(false)
    } else {
      setNavMenuOpen(true)
    }
    refresh(Math.random())
  }, [setNavMenuOpen])

  React.useEffect(() => {
    const handler = (e: Event) => {
      // @ts-ignore
      if (!e.target?.closest('div#nav-menu')) {
        setNavMenuOpen(false)
      }
    }
    document.addEventListener('click', handler)

    return () => {
      document.removeEventListener('click', handler)
    }
  }, [setNavMenuOpen])

  React.useEffect(() => {
    smallScreenMediaQuery.addEventListener('change', handleScreenSizeChange)

    return () => {
      smallScreenMediaQuery.removeEventListener(
        'change',
        handleScreenSizeChange,
      )
    }
  }, [handleScreenSizeChange])

  React.useEffect((): common.EmptyFn => {
    if (customerID) {
      common.dispatch(common.subToSingleCustomer({ customerID }))

      return (): void => {
        common.dispatch(common.unSubFromSingleCustomer({ customerID }))
      }
    }
    return common.EMPTY_FN
  }, [customerID])

  // const lastTimeout = React.useRef(setTimeout(common.EMPTY_FN, 0))
  // const lastTimeoutColor = React.useRef(setTimeout(common.EMPTY_FN, 0))

  const navigate = useNavigate()
  const handleCustomerReport = React.useCallback(() => {
    navigate(`/customers/${customerID}/report`)
    // }
  }, [customerID, navigate])

  const handleGoAssessmentMedia = React.useCallback((): void => {
    document.querySelector('#assessment')?.scrollIntoView()
    toggleNavMenu()
  }, [toggleNavMenu])
  const handleGoToDocumentation = React.useCallback((): void => {
    document.querySelector('#documentation')?.scrollIntoView()
    toggleNavMenu()
  }, [toggleNavMenu])
  const handleGoToRoofClaims = React.useCallback((): void => {
    document.querySelector('#roof-claims')?.scrollIntoView()
    toggleNavMenu()
  }, [toggleNavMenu])
  const handleGoToSecurity = React.useCallback((): void => {
    document.querySelector('#security')?.scrollIntoView()
    toggleNavMenu()
  }, [toggleNavMenu])
  const handleGoToSolarSurvey = React.useCallback((): void => {
    document.querySelector('#site-survey')?.scrollIntoView()
    toggleNavMenu()
  }, [toggleNavMenu])

  const handleGoToCCTVSim = React.useCallback(() => {
    toggleCCTVSim()
    toggleNavMenu()
  }, [toggleCCTVSim, toggleNavMenu])

  const payMethodHandleFromNavMenu = React.useCallback(() => {
    payMethodToggle()
    toggleNavMenu()
  }, [payMethodToggle, toggleNavMenu])

  const handleCloserCalcFromNavMenu = React.useCallback(() => {
    toggleCloserCalc()
    toggleNavMenu()
  }, [toggleCloserCalc, toggleNavMenu])

  const handleNavToEfficiency = React.useCallback(
    (field: c.CustomerField) => {
      document.querySelector('#' + field)?.scrollIntoView()
      toggleNavMenu()
    },
    [toggleNavMenu],
  )

  const handleDeleteCustomer = React.useCallback((): void => {
    if (
      window.confirm(
        `Are you sure you want to delete the customer ${customer.customerName}`,
      )
    ) {
      c.deleteCustomer(customerID)
    }
  }, [customer.customerName, customerID])

  // React.useEffect(() => {
  //   if (location.hash) {
  //     const efficiency = location.hash.slice(1)

  //     const targetScroll = document.getElementById(efficiency as string)

  //     const res = common.verifyEmptyFields(customer)
  //     if (res.empty) {
  //       console.log(JSON.stringify(res))
  //       clearTimeout(lastTimeout.current)
  //       lastTimeout.current = setTimeout(() => {
  //         targetScroll?.scrollIntoView({
  //           behavior: 'smooth',
  //           block: common.isLargeEfficiency(
  //             res.targetScroll as keyof common.Customer,
  //           )
  //             ? 'start'
  //             : 'center',
  //         })
  //         if (targetScroll) {
  //           targetScroll.style.borderRadius = '10px'
  //           targetScroll.style.backgroundColor = '#b2e2f2'
  //           clearTimeout(lastTimeoutColor.current)
  //           lastTimeoutColor.current = setTimeout(() => {
  //             targetScroll.style.backgroundColor = 'unset'
  //             targetScroll.style.borderRadius = 'unset'
  //             location.hash = ''
  //           }, 1600)
  //         }
  //         setFillAlert(true)
  //       }, 1200)
  //     }
  //   }
  //   const efficiency = location.hash.slice(1)

  //   const targetScroll = document.getElementById(efficiency as string)

  //   const res = common.verifyEmptyFields(customer)
  //   if (!res.empty) {
  //     clearTimeout(lastTimeout.current)
  //     return
  //   }

  //   clearTimeout(lastTimeout.current)
  //   lastTimeout.current = setTimeout(() => {
  //     targetScroll?.scrollIntoView({
  //       behavior: 'smooth',
  //       block: common.isLargeEfficiency(
  //         res.targetScroll as unknown as keyof Customer,
  //       )
  //         ? 'start'
  //         : 'center',
  //     })
  //     if (targetScroll) {
  //       targetScroll.style.borderRadius = '10px'
  //       targetScroll.style.backgroundColor = '#b2e2f2'
  //       clearTimeout(lastTimeoutColor.current)
  //       lastTimeoutColor.current = setTimeout(() => {
  //         targetScroll.style.backgroundColor = 'unset'
  //         targetScroll.style.borderRadius = 'unset'
  //         location.hash = ''
  //       }, 1600)
  //     }
  //     setFillAlert(true)
  //   }, 1200)
  // }, [customer, location])

  React.useEffect(() => {
    common.dispatch(common.efficiencyPricesAction())
  }, [])

  if (!customerID) {
    return <NotFound />
  }

  if (customer.deleted) {
    return (
      <div className={gStyles['content-holder']}>
        <h3>
          This customer ({customer.customerName || customerID}) has been deleted
        </h3>

        <code>{customerID}</code>

        <br />

        <Link to="/customers">Go back</Link>
      </div>
    )
  }

  return (
    <div className={styles['root']}>
      {/* Breadcrumb height */}
      <cpm.Pad amt={28} />

      <div className={gStyles['content-holder']}>
        <rn.View style={themedGStyles.content}>
          <div className={gStyles['width-100']}>
            <cpm.Text bold on="canvas" size={24}>
              Customer Info
            </cpm.Text>
          </div>

          <cpm.Field customerID={customerID} field="createdAt" on="canvas" />
          <cpm.Field customerID={customerID} field="sort_key" on="canvas" />
          <cpm.Field customerID={customerID} field="customerName" on="canvas" />
          <cpm.Field
            customerID={customerID}
            field="customerEmail"
            on="canvas"
          />
          <cpm.Field
            customerID={customerID}
            field="customerAddress"
            on="canvas"
          />
          <cpm.Field
            customerID={customerID}
            field="customerPhone"
            on="canvas"
          />
          <cpm.Field
            customerID={customerID}
            field="customerPhoneAlt"
            on="canvas"
          />

          {!!c.CustomerSchema.ssn && (
            <cpm.Field customerID={customerID} field="ssn" on="canvas" />
          )}

          {c.CODENAME !== 'nirvana' && (
            <cpm.Field
              customerID={customerID}
              field="solarCompany"
              on="canvas"
            />
          )}

          <cpm.Field customerID={customerID} field="products" on="canvas" />

          {c.CODENAME !== 'nirvana' && (
            <cpm.Field
              customerID={customerID}
              field="main_panel_upgrade_installation_company"
              on="canvas"
            />
          )}

          <cpm.Field customerID={customerID} field="globalNotes" on="canvas" />

          <cpm.TextInput
            editable={false}
            label="Total cost (company)"
            on="canvas"
            shrink
            value={totalCostCompany.toFixed(2)}
          />

          <cpm.TextInput
            editable={false}
            label="Total cost (customer)"
            on="canvas"
            shrink
            value={totalCostCustomer.toFixed(2)}
          />
        </rn.View>

        {gs.rowGap12}

        {gs.rowGap12}

        <rn.View style={themedGStyles.content}>
          <div className={gStyles['width-100']}>
            <cpm.Text bold on="canvas" size={24}>
              House Info
            </cpm.Text>
          </div>

          <cpm.Field
            customerID={customerID}
            field="yearHomeBuilt"
            on="canvas"
          />

          <cpm.Field
            customerID={customerID}
            field="attic_square_footage"
            on="canvas"
          />

          {c.CODENAME === 'nirvana' && (
            <cpm.Field
              customerID={customerID}
              field="roof_shingles_or_tiles"
              on="canvas"
            />
          )}

          {!!c.CustomerSchema.homeStoryNumber && (
            <cpm.Field
              customerID={customerID}
              field="homeStoryNumber"
              on="canvas"
            />
          )}

          {!!c.CustomerSchema.buildingType && (
            <cpm.Field
              customerID={customerID}
              field="buildingType"
              on="canvas"
            />
          )}
        </rn.View>

        {gs.rowGap12}

        <rn.View style={themedGStyles.content}>
          <div className={gStyles['width-100']}>
            <cpm.Text bold on="canvas" size={24}>
              Rep Info
            </cpm.Text>
          </div>

          {c.CustomerSchema.solarRep && (
            <cpm.Field customerID={customerID} field="solarRep" on="canvas" />
          )}
          {common.IS_MAIN && (
            <cpm.Field customerID={customerID} field="solarEmail" on="canvas" />
          )}

          <cpm.Field customerID={customerID} field="homeRep" on="canvas" />

          <cpm.Field customerID={customerID} field="crm_id" on="canvas" />

          <cpm.TextInput
            editable={false}
            elementLeftBlurred={inputDecors.externalLink}
            elementLeftFocused={inputDecors.externalLink}
            label="Rep commission"
            on="canvas"
            onPressElementLeft={payMethodToggle}
            shrink
            value={appliedLoan?.finalCommission.toFixed(2) || ''}
          />

          {c.IS_MAIN && (
            <cpm.Field
              customerID={customerID}
              field="security_alarm_payout"
              on="canvas"
            />
          )}
        </rn.View>

        {gs.rowGap12}

        <rn.View style={themedGStyles.content}>
          <cpm.Text bold on="canvas" size={24}>
            Adders
          </cpm.Text>
        </rn.View>

        {c.efficiencyKeys.map((field) => (
          <ErrorBoundary
            fallback={errorBoundaryFallback[field]}
            key={customerID + '/' + field}
          >
            <cpm.CheckGroup as="paper" customerID={customerID} field={field} />
          </ErrorBoundary>
        ))}
      </div>

      <MediaInput customerID={customerID} ofWhat="owner_house" />

      {categoryToMediaKindsEntries.map(([category, mediaKinds]) => (
        <React.Fragment key={customerID + '/' + category}>
          <div className={gStyles['content-holder']} id={kebabCase(category)}>
            <rn.View style={themedGStyles.content}>
              <cpm.Text bold on="canvas" size={26}>
                {category}
              </cpm.Text>
            </rn.View>
          </div>

          {mediaKinds.map((mk) => (
            <MediaInput
              customerID={customerID}
              key={`${customerID}/${category}/${mk}`}
              ofWhat={mk as c.MediaKind}
            />
          ))}
        </React.Fragment>
      ))}

      {(currProducts.includes('Security') ||
        (currProducts.length === 0 && c.CODENAME !== 'nirvana')) && (
        <>
          <div className={gStyles['content-holder']} id="security">
            <rn.View style={themedGStyles.content}>
              <cpm.Text bold on="canvas" size={26}>
                CCTV Simulator:
              </cpm.Text>
            </rn.View>
          </div>

          {securityCamsMediaKinds.map((mediaKind) => (
            <MediaInput
              customerID={customerID}
              key={customerID + '/security/' + mediaKind}
              ofWhat={mediaKind}
            />
          ))}
        </>
      )}

      {c.CODENAME !== 'glow' &&
        (currProducts.includes('Solar') || currProducts.length === 0) && (
          <>
            <div className={gStyles['content-holder']} id="site-survey">
              <rn.View style={themedGStyles.content}>
                <cpm.Text bold on="canvas" size={26}>
                  Site Survey:
                </cpm.Text>
              </rn.View>
            </div>

            {solarSurveyMediaKinds.map((mediaKind) => (
              <MediaInput
                customerID={customerID}
                key={customerID + '/solarSurvey/' + mediaKind}
                ofWhat={mediaKind}
              />
            ))}
          </>
        )}

      {false && (currProducts.includes('RC') || currProducts.length === 0) && (
        <>
          <div className={gStyles['content-holder']} id="roof-claims">
            <rn.View style={themedGStyles.content}>
              <cpm.Text bold on="canvas" size={26}>
                Roof Claims:
              </cpm.Text>
            </rn.View>
          </div>

          {c.roofClaimsMediaKinds.map((mediaKind) => (
            <MediaInput
              customerID={customerID}
              key={customerID + '/roofClaims/' + mediaKind}
              ofWhat={mediaKind}
            />
          ))}

          <div className={gStyles['content-holder']}>
            <rn.View style={themedGStyles.content}>
              <cpm.ConnectedInput
                customerID={customerID}
                field="roof_claiming_notes"
                on="canvas"
              />

              <rn.View style={themedGStyles.separatorH} />
            </rn.View>
          </div>
        </>
      )}

      {gs.rowGap16}

      <div className={gStyles['content-holder']}>
        <div style={gs.column}>
          <Mui.Typography onClick={handleCustomerReport} sx={sx['reportLink']}>
            Customer Report
          </Mui.Typography>
          <Pad amt={20} />
          {(currProducts.includes('Security') ||
            (currProducts.length === 0 && c.CODENAME !== 'nirvana')) && (
            <>
              <Mui.Typography onClick={handleGoToCCTVSim} sx={sx['reportLink']}>
                CCTV Simulator
              </Mui.Typography>
              <Pad amt={20} />
            </>
          )}
          {(currProducts.includes('HIL') ||
            currProducts.includes('Security') ||
            currProducts.length === 0) && (
            <>
              <Mui.Typography onClick={payMethodToggle} sx={sx['reportLink']}>
                Payment Method
              </Mui.Typography>
              <Pad amt={20} />
            </>
          )}
          {(currProducts.includes('Solar') || currProducts.length === 0) && (
            <>
              <Mui.Typography onClick={toggleCloserCalc} sx={sx['reportLink']}>
                Solar Calculator
              </Mui.Typography>
              <Pad amt={20} />
            </>
          )}
          {false && common.IS_MAIN && (
            <>
              <Mui.Typography
                onClick={handleCustomerReport}
                sx={sx['reportLink']}
              >
                Customer Report
              </Mui.Typography>
              <Pad amt={20} />
            </>
          )}

          {common.IS_MAIN && (
            <>
              <Link
                className={styles['report-links']}
                to={`/customers/${customerID}/services`}
              >
                Energy Efficiencies Report{' '}
              </Link>

              <Pad amt={20} />
            </>
          )}

          <Mui.Typography onClick={toggleMpuCalculator} sx={sx['reportLink']}>
            MPU Calculator
          </Mui.Typography>

          <Pad amt={20} />

          <Mui.Typography
            onClick={handleDeleteCustomer}
            sx={sx['reportLinkRed']}
          >
            Delete customer
          </Mui.Typography>

          <Pad amt={20} />
        </div>
      </div>

      <MpuCalculator
        onRequestClose={toggleMpuCalculator}
        visible={mpuCalculatorOpen}
      />

      <cp.Dialog fullWidth onClose={toggleCCTVSim} open={cctvSimOpen}>
        <cpm.CCTVSim
          containerHeight={768}
          // Keep in sync with Dialog.module.css
          containerWidth={1024}
          customerID={customerID}
        />
      </cp.Dialog>

      <cp.Dialog
        onClose={toggleCloserCalc}
        open={closerCalcOpen}
        title="Solar Calculator"
      >
        <CloserCalc customerID={customerID} />
      </cp.Dialog>

      {/* <Mui.Modal onClose={handleCloseOldCustomerAlert} open={oldCustomerAlert}>
        <Mui.Box component={Mui.Paper} sx={sx['modalBoxStyle']}>
          <Mui.Alert severity="error" sx={sx['alertTextStyle']}>
            The creation date of this customer is before 03/24/2023 , If you
            need to update the price, click on “update prices” on the correspond
            efficiency
          </Mui.Alert>
          <Pad amt={30} />
          <Mui.Button
            onClick={handleCloseOldCustomerAlert}
            sx={sx['alertButtonStyle']}
            variant="contained"
          >
            OK
          </Mui.Button>
        </Mui.Box>
      </Mui.Modal> */}

      {!navMenuOpen && !cctvSimOpen && (
        <rn.TouchableOpacity onPress={toggleNavMenu} style={mStyles.menuIcon}>
          <SimpleLineIcons
            color={t.backdrop.color as string}
            name="menu"
            size={16}
          />
        </rn.TouchableOpacity>
      )}

      <NavMenu
        availNonCustomEfficiencies={availNonCustomEfficiencies}
        canHide={smallScreenMediaQuery.matches || cctvSimOpen}
        customerID={customerID}
        hide={!navMenuOpen || cctvSimOpen}
        onPressCustomerReport={handleCustomerReport}
        onPressAssessment={handleGoAssessmentMedia}
        onPressCCTVSim={handleGoToCCTVSim}
        onPressCommissionCalc={handleCloserCalcFromNavMenu}
        onPressDocumentation={handleGoToDocumentation}
        onPressEfficiency={handleNavToEfficiency}
        onPressPayMethod={payMethodHandleFromNavMenu}
        onPressRoofClaims={handleGoToRoofClaims}
        onPressSecurity={handleGoToSecurity}
        onPressSolarSurvey={handleGoToSolarSurvey}
      />

      <cp.Breadcrumbs />
    </div>
  )
})

// const Accordion = styled((props: AccordionProps) => (
//   <MuiAccordion disableGutters elevation={0} square {...props} />
// ))(({ theme }) => ({
//   border: `1px solid ${theme.palette.divider}`,
//   '&:not(:last-child)': {
//     borderBottom: 0,
//   },
//   '&:before': {
//     display: 'none',
//   },
// }))

// const AccordionSummary = styled((props: AccordionSummaryProps) => (
//   <MuiAccordionSummary
//     expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
//     {...props}
//   />
// ))(({ theme }) => ({
//   backgroundColor:
//     theme.palette.mode === 'dark'
//       ? 'rgba(255, 255, 255, .05)'
//       : 'rgba(0, 0, 0, .03)',
//   flexDirection: 'row-reverse',
//   '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
//     transform: 'rotate(90deg)',
//   },
//   '& .MuiAccordionSummary-content': {
//     marginLeft: theme.spacing(1),
//   },
// }))

// const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
//   padding: theme.spacing(2),
//   borderTop: '1px solid rgba(0, 0, 0, .125)',
// }))

const reportLink = {
  alignSelf: 'left',
  color: 'blue',
  cursor: 'pointer',
  fontFamily: c.light.fontFamily,
  margin: 0,
  textDecoration: 'none',
  '&:hover': {
    color: 'black',
  },
}
export const rootSurfaceCustomer: c.Surface = 'canvas'
const sx = {
  alertTextStyle: {
    fontSize: {
      sm: '22px',
      xs: '16px',
    },
    textAlign: 'justify',
  },
  alertButtonStyle: {
    fontSize: {
      sm: '24px',
      xs: '18px',
    },
    marginTop: 'auto',
  },
  fillFieldsAlertStyle: {
    fontSize: '18px',
    width: '298px',
  },
  inputGroupStyle: {
    alignContent: { xs: 'center', sm: 'flex-start' },
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',

    paddingTop: '40px',
    position: 'relative',
    paddingLeft: '24px',
    paddingRight: '24px',
    maxWidth: '100vw',
  },
  inputMediaWrapperStyle: {
    display: 'flex',
    height: '70px',
    width: '100%',
  },
  inputMediaWrapperHideStyle: {
    display: {
      lg: 'none',
      xs: 'flex',
    },
    height: '70px',
    width: '100%',
  },
  modalBoxStyle: {
    alignItems: 'center',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    left: '50%',
    padding: '20px',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
      sm: '500px',
      xs: '320px',
    },
  },
  textBreadCrumbStyle: {
    alignItems: 'center',
    display: 'flex',
  },
  reportLink,
  reportLinkRed: {
    ...reportLink,
    alignSelf: 'left',
    color: 'red',
    cursor: 'pointer',
    margin: 0,
    textDecoration: 'none',
    '&:hover': {
      color: 'black',
    },
  },
  wrapperCustomerLgHeighAutoStyle: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
    overflowY: 'auto',
    position: 'relative',
    width: '100%',
  },
  wrapperCustomerLgHeightStyle: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: {
      lg: 'calc( 100% - 70px )',
      xs: 'auto',
    },
    overflowY: 'auto',
    position: 'relative',
    width: '100%',
  },
}

const errorBoundaryFallback = (() => {
  const res: Partial<Record<c.CustomerField, JSX.Element>> = {}
  for (const field of c.efficiencyKeys) {
    res[field] = (
      <div
        style={{
          padding: 24,
          borderColor: '#CCCCCC',
          borderStyle: 'solid',
          borderWidth: 1,
        }}
      >
        <span>
          Something went wrong with the "{c.getFieldLabel(field)}" efficiency,
          please report to Dev Dpt.
        </span>
      </div>
    )
  }
  return res as Record<c.CustomerField, JSX.Element>
})()

const themedStyles = gs.ThemedStyleSheet.create((t) => ({
  menuIcon: {
    ...gs.shadowFullSoft,
    backgroundColor: t.backdrop.backgroundColor,
    borderRadius: Number.MAX_SAFE_INTEGER,
    // @ts-ignore 'fixed' not available on mobile
    position: (r.isWeb ? 'fixed' : 'absolute') as 'absolute',
    right: Number(t.canvas.gap) * 2,
    bottom: t.canvas.gap,
    padding: 32,
  },
}))
